export default {
    GENESYS_BLUE_60: "#2A60C8",
    GENESYS_BLUE_10: "#172B52",
    GENESYS_BLACK_100: "#77828F",
    GENESYS_YELLOW_60: "#FFAE00",
};
